import Store from '@/store';
import Logger from '@/utils/logger';
import SessionUtil from '@/utils/session';

export default {
  guard: async (to) => {
    const validSession = await SessionUtil.validateSession();

    // Login session is valid
    // Pass to next guard
    if (validSession) {
      return;
    }

    // Login session is invalid

    // Clear session data
    await Store.dispatch('clearSession');

    // Forward to login page
    if (to.path === '/' || to.path === '/dashboard') {
      Logger.debug('Kick out');
      throw new Error('$KickOut');
    }

    // Go to login to back to backward page
    Logger.debug(`Kick out from: ${to.path}`);
    throw new Error('$LoginBack');
  },
};
